import { render, staticRenderFns } from "./MiniWizardManager.vue?vue&type=template&id=13d6952c"
import script from "./MiniWizardManager.vue?vue&type=script&lang=js"
export * from "./MiniWizardManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports